import store from '@/state/store'
const hasAccessAll = store.getters['identity/hasAccessAll']

import { formatDate, formatDuration } from '../../helpers/format-values'

export const fields = () => {
  return [
    {
      label: 'No. Pengiriman',
      key: 'number',
      rowspan: 2,
      isShow: true,
    },
    {
      label: 'No. Penugasan',
      key: 'fleet_task.number',
      rowspan: 2,
      isShow: true,
    },
    {
      label: 'Pengemudi',
      key: 'fleet_task.driver_user.name',
      rowspan: 2,
      isShow: true,
    },
    {
      label: 'Plat Nomor',
      key: 'fleet_task.vehicle.license_plate',
      rowspan: 2,
      isShow: true,
    },
    {
      label: 'Pelanggan Penerima',
      key: 'shipped_customer.name',
      rowspan: 2,
      isShow: true,
    },
    {
      label: 'Vendor',
      key: 'vendor.name',
      rowspan: 2,
      isShow: hasAccessAll(['vms:create', 'vms:read', 'vms:update', 'vms:delete']),
    },
    {
      label: 'Muatan',
      key: 'loads',
      rowspan: 2,
      isShow: true,
    },
    {
      label: 'Lokasi Awal Keberangkatan',
      key: 'fleet_task.start_address.name',
      rowspan: 2,
      isShow: true,
    },
    {
      label: 'Lokasi Akhir Keberangkatan',
      key: 'fleet_task.end_address.name',
      rowspan: 2,
      isShow: true,
    },
    {
      label: 'Lokasi Ambil Muatan',
      key: 'origin_address.name',
      rowspan: 2,
      isShow: true,
    },
    {
      label: 'Lokasi Kirim Muatan',
      key: 'destination_address.name',
      rowspan: 2,
      isShow: true,
    },
    {
      label: 'Target',
      key: 'target',
      rowspan: 1,
      colspan: 2,
      isShow: true,
      fields: [
        {
          label: 'Target Ambil',
          key: 'expected_pickup_on',
          colspan: 1,
          format: (value) => formatDate(value),
        },
        {
          label: 'Target Kirim',
          key: 'expected_delivered_on',
          colspan: 1,
          format: (value) => formatDate(value),
        },
      ],
    },
    {
      label: 'Aktual',
      key: 'actual',
      rowspan: 1,
      colspan: 2,
      isShow: true,
      fields: [
        {
          label: 'Aktual Ambil',
          key: 'actual_pickup_on',
          colspan: 1,
          format: (value) => formatDate(value),
        },
        {
          label: 'Aktual Kirim',
          key: 'actual_delivered_on',
          colspan: 1,
          format: (value) => formatDate(value),
        },
      ],
    },
    {
      label: 'Selisih Waktu Ambil (menit)',
      key: 'picked_on_diff',
      rowspan: 2,
      isShow: true,
      format: (value) => formatDuration(value),
    },
    {
      label: 'Selisih Waktu Kirim (menit)',
      key: 'delivered_on_diff',
      rowspan: 2,
      isShow: true,
      format: (value) => formatDuration(value),
    },
    {
      label: 'Ketepatan Waktu Ambil',
      key: 'on_time_pickup',
      rowspan: 2,
      isShow: true,
      format: (value) => {
        if (value == null) return '-'

        return value ? 'Tepat Waktu' : 'Terlambat'
      },
    },
    {
      label: 'Ketepatan Waktu Kirim',
      key: 'on_time_drop',
      rowspan: 2,
      isShow: true,
      format: (value) => {
        if (value == null) return '-'

        return value ? 'Tepat Waktu' : 'Terlambat'
      },
    },
  ]
}
